import 'arrayq';

import { PureConnect, React } from '../../react';
import { IQuestionDB } from '../../types';
import cx from './questionLinkEditor.less';
import windowSelectors from '../../window/selectors';
import selectors from './selectors';
import reselectors from './reselectors';
import { notesResource } from '../notes/resource';
import CollapsiblePanel from '../collapsiblePanel';
import { Btn } from '../../react-toolbox-redesign/button';
import { questionsEditor } from './resource';
import FocusLockFocusGuard from '../../focuslock/focuslockext';
import QUESTION_LINK from './action/QUESTION_LINK';
import { notesSharedResource } from '../noteshared/resource';
import adminReselectors from '../admin/reselectors';
import QUESTION_SHOWLINKS from './action/QUESTION_SHOWLINKS';
import SEARCH_TERM_LINK from './action/QUESTION_SEARCH_TERM_LINK';

export default PureConnect(`LinkQuestionEditModal`)(
    (state) => ({
        linkitem: selectors.linkitem(state), 
        notes: notesResource.selectors.items(state).concat(notesSharedResource.selectors.items(state)),        
        linking: selectors.linking(state),    
        screenSmall: windowSelectors.small(state),  
        searchTermLinking: selectors.searchTermLinkingSelector(state), 
        allquestions: adminReselectors.questionsItemsSelector(state),
        unlinkedQuestions: reselectors.questionSelectorSearching(state),
        // accountmng: authmng.accountmanager(state),
    }),
    (dispatch) => ({ 
        cancel: () => dispatch(QUESTION_LINK({linkvisible: false, linkitem: undefined })),
        change: (item: IQuestionDB | any) => { dispatch(questionsEditor.actions.APPLY({ item }));},
        setlinkid: (linkitem: IQuestionDB) => dispatch(QUESTION_LINK({linkvisible: true, linkitem: linkitem })),        
        updateSearchTerm: (searchTermLinking: string) => { dispatch(SEARCH_TERM_LINK({ searchTermLinking: searchTermLinking })); },
    }),
    ({ linking, linkitem, setlinkid, notes, allquestions, unlinkedQuestions, screenSmall, searchTermLinking, updateSearchTerm }) => {

        var selected = notes.qFirst((x) => x.id === (linkitem ? linkitem.parentId: undefined));
        var searchTermShowing = !searchTermLinking ? 'Selecteer': searchTermLinking;

        return (
            <div className={cx((!linking) ? 'wcag-invisible' : '', 'container')}  
                aria-hidden={!(linking)} 
                aria-labelledby= "Linken">
                <FocusLockFocusGuard
                    disabled={!(linking)}>   
                    <CollapsiblePanel defaultOpened={false} label={selected? selected.text : searchTermShowing}>
                        <div className={cx('input-search-container')}>
                            <input id="link-input-$`{linkitem.id}`" placeholder="Zoeken..." name="q" className={cx('input-search')} ref="term" value={searchTermLinking} onChange={(x) => updateSearchTerm(x.target.value)} />
                        </div>                        
                        <div className={cx('search-list')}>
                          { unlinkedQuestions
                                .qSelect((unlinked) => {
                                    return (<div tabIndex={0} key={`keyquestion` + unlinked.id.toString()} className={cx('item')}
                                    onKeyDown={(ev) => {
                                        ev.preventDefault(); 
                                        linkitem.parentId=unlinked.id;
                                        linkitem.status=unlinked.status;
                                        linkitem.antwoordConcern=unlinked.antwoordConcern;
                                        setlinkid(linkitem);
                                    }}
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        linkitem.parentId=unlinked.id;
                                        linkitem.status=unlinked.status;
                                        linkitem.antwoordConcern=unlinked.antwoordConcern;                                    
                                        setlinkid(linkitem);
                                    }}
                                    >
                                        <label className={cx('selection-container')}>{unlinked.text}
                                        </label>
                
                                    </div>);                                
                                
                        })}                    
                        </div>
                    </ CollapsiblePanel>
                        
                </FocusLockFocusGuard>
            </div>         
        );
});

export const CommitLinkQuestionModal = PureConnect(`CommitLinkQuestionModal`)(
    (state) => ({
        linking: selectors.linking(state),
        linkitem: selectors.linkitem(state),   
    }),
    (dispatch) => ({
        cancelLinking: (linkitem: IQuestionDB) => dispatch(QUESTION_LINK({linkvisible: false, linkitem: linkitem })),
        applyLinking: (linkitem: IQuestionDB) => dispatch(QUESTION_LINK({linkvisible: false, linkitem: linkitem })),
    }),
    ({ linking, linkitem, cancelLinking, applyLinking }) => {
        const visible=linking;
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Maak een notitie aan">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container', !visible ? 'wcag-invisible' : '')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt,() => cancelLinking(linkitem));
                            }}
                            onClick={() => cancelLinking(linkitem)}
                        >
                            <span>Annuleren</span>
                        </Btn>
    
                        <Btn
                            type="button"
                            className={'btn'}
                            aria-label={'Koppelen'}
                            aria-haspopup={false}
                            tabIndex={!!linkitem ? 0 : -1}
                            disabled={!linkitem}
                            onKeyDown={(evt: any) => 
                                handleEnters(evt, () => applyLinking(linkitem))
                            }
                            onClick={ () => applyLinking(linkitem) }
                        >
                            <span>Koppelen</span>
                        </Btn>
                    </div>
    
                </div>
            </div>
    
        );
    });

export const LinksOfQuestionModal = PureConnect(`LinksOfQuestionModal`)(
    (state) => ({
        showitem: selectors.showitem(state),
        showlinks: selectors.showlinks(state),
        notes: notesResource.selectors.items(state).concat(notesSharedResource.selectors.items(state)),        
        linking: selectors.linking(state),    
        screenSmall: windowSelectors.small(state),  
        searchTermLinking: selectors.searchTermLinkingSelector(state), 
        allquestions: adminReselectors.questionsItemsSelector(state), 
        // accountmng: authmng.accountmanager(state),
    }),
    (dispatch) => ({ 
        cancel: () => dispatch(QUESTION_LINK({linkvisible: false, linkitem: undefined })),
    }),
    ({ showlinks, showitem, allquestions, screenSmall, searchTermLinking }) => {

        const linkedQuestions = allquestions.qWhere((z)=>z.parentId === (showitem ? showitem.noteId:'') );
        return (
            <div className={cx((!showlinks) ? 'wcag-invisible' : '', 'container-linked')}  
                aria-hidden={!(showlinks)} 
                aria-labelledby= "Linken">
                <div className={cx('list')}>
                    { linkedQuestions
                        .qSelect((linked) => {
                            return (<div tabIndex={0} key={`keyquestion` + linked.id.toString()} className={cx('item')}>
                                <label className={cx('selection-container')}>{linked.text}</label>
                            </div>);                                 
                })}                    
                </div>        
            </div>         
        );
});

export const LinksOfQuestionModalCancel = PureConnect(`LinksOfQuestionModalCancel`)(
    (state) => ({
        showlinks: selectors.showlinks(state),
        showitem: selectors.showitem(state),
    }),
    (dispatch) => ({
        cancelLinking: (showitem: IQuestionDB) => dispatch(QUESTION_SHOWLINKS({showlinks: false, showitem: showitem })),
    }),
    ({ showlinks, showitem, cancelLinking }) => {
        const visible=showlinks;
        return (
            <div className={cx('bottom-panel', (!visible) ? 'wcag-invisible' : '')}
                aria-hidden={!(visible)}
                aria-labelledby="Toon links van vraag">
                {/* WCAG (button):
                            1) no role; they are buttons
                            2) focussable (Tab)
                            3) toggle function: n/a (when true use aria-checked)
                            4) aria-expanded: n/a
                            5) aria-haspopup: n/a  
                            6) aria-labelledby/aria-describedby: ref to label
                            7) icon of button is explained by tekst-> aria-hidden*/}
                <div className={cx('bottom-buttons')}>
                    <div className={cx('buttons-container', !visible ? 'wcag-invisible' : '')}>
                        <Btn
                            type="button"
                            className={'btn'}
                            extraClassNames={'secondary-btn'}
                            aria-label={'Annuleren'}
                            aria-haspopup={false}
                            tabIndex={0}
                            onKeyDown={(evt: any) => {
                                handleEnters(evt,() => cancelLinking(showitem));
                            }}
                            onClick={() => cancelLinking(showitem)}
                        >
                            <span>Annuleren</span>
                        </Btn>

                    </div>
    
                </div>
            </div>
    
        );
    });

function handleEnters(evt: React.KeyboardEvent<HTMLDivElement>, funct: () => void) {
    if (evt.key === 'Enter') { evt.preventDefault(); funct(); }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/questionLinkEditor.tsx